import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e3d980e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-view-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "leak-number"
}
const _hoisted_3 = {
  key: 0,
  class: "red-text"
}
const _hoisted_4 = {
  key: 1,
  class: "gray-text"
}
const _hoisted_5 = {
  key: 1,
  class: "leak-number red-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupTreeSelector = _resolveComponent("GroupTreeSelector")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_TerminalIconName = _resolveComponent("TerminalIconName")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_UnauthorizedTooltip = _resolveComponent("UnauthorizedTooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_RepairDrawer = _resolveComponent("RepairDrawer")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SearchFilterBar, {
        style: {"padding":"16px 16px 0","background-color":"var(--cm-color-card-bg)"},
        modelValue: _ctx.queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryParams) = $event)),
        "form-columns": _ctx.filterFormColumns,
        "show-search": true,
        "search-placeholder": _ctx.$t('common.phComputerIpUser'),
        "popover-threshold": 2,
        onSearch: _ctx.handleSearch,
        onQuery: _ctx.handleQuery,
        onReset: _ctx.handleReset
      }, {
        group_id: _withCtx(() => [
          _createVNode(_component_GroupTreeSelector, {
            width: "100%",
            "model-value": _ctx.queryParams.group_id,
            onSelected: _ctx.updateGroupId
          }, null, 8, ["model-value", "onSelected"])
        ]),
        actions: _withCtx(() => [
          (_ctx.viewMode === _ctx.TableViewMode.preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.viewAllTerminals')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "search-placeholder", "onSearch", "onQuery", "onReset"]),
      _createElementVNode("div", {
        class: "table-wrapper",
        style: _normalizeStyle({ height: _ctx.viewMode === _ctx.TableViewMode.full ? 'calc(100% - 40px)' : '400px' })
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          "min-width": "100%",
          height: _ctx.viewMode === _ctx.TableViewMode.full ? '100%' : undefined,
          data: _ctx.tableData,
          "tooltip-effect": "light",
          onSortChange: _ctx.handlerSort
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('listColumns.computerName')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_TerminalIconName, {
                  computer_name: scope.row.computer_name,
                  system_type: scope.row.system_type,
                  login_status: scope.row.login_status
                }, null, 8, ["computer_name", "system_type", "login_status"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('listColumns.userMark'),
              prop: "user_mark",
              "min-width": "130"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('listColumns.groupName'),
              prop: "group_name",
              "min-width": "130"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('listColumns.ipAddress'),
              "min-width": "130"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_IPColumn, {
                  cip: scope.row.client_ip,
                  sip: scope.row.system_ip
                }, null, 8, ["cip", "sip"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('safeProtectionModule.os'),
              prop: "os",
              "min-width": "180"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('safeProtectionModule.leakHighRiskCountSlashTotal'),
              "min-width": "130"
            }, {
              default: _withCtx((scope) => [
                (_ctx.getAuthByList(scope.row.auth_status, _ctx.ModulePermissionKey[_ctx.AreaType.linux]) === _ctx.TerminalAuthStatus.normal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (scope.row.leak_count)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.high_risk_count), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.high_risk_count), 1)),
                      _createElementVNode("span", null, " / " + _toDisplayString(scope.row.leak_count), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('safeProtectionModule.servicePrefix')) + _toDisplayString(_ctx.authStatusLabelI18n[_ctx.getAuthByList(scope.row.auth_status, _ctx.ModulePermissionKey[_ctx.AreaType.linux])]), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "scan_status",
              label: _ctx.$t('safeProtectionModule.scanStatusCol'),
              "min-width": "130"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.leakScanStatusI18n[scope.row.scan_status]), 1),
                _createElementVNode("div", {
                  class: _normalizeClass({'dot-flashing': scope.row.scan_status === 1 })
                }, null, 2)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('safeProtectionModule.colOperation'),
              "min-width": "90"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_UnauthorizedTooltip, {
                  "permission-key": _ctx.ModulePermissionKey[scope.row.area_type],
                  "device-id": scope.row.device_id,
                  "auth-status": _ctx.getAuthByList(scope.row.auth_status, _ctx.ModulePermissionKey[scope.row.area_type]),
                  "area-type": scope.row.area_type,
                  onAuthSuccess: _ctx.getData
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small",
                      disabled: _ctx.isDisabled(scope.row),
                      onClick: ($event: any) => (_ctx.repairTerminal(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.system_type === 2 ? _ctx.$t('safeProtectionModule.leakDetailBtn') : _ctx.$t('safeProtectionModule.repairLeakBtn')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["permission-key", "device-id", "auth-status", "area-type", "onAuthSuccess"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "height", "data", "onSortChange"])), [
          [_directive_loading, _ctx.isLoading],
          [_directive_load_more, _ctx.loadMoreData]
        ])
      ], 4),
      (_ctx.viewMode === _ctx.TableViewMode.full)
        ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
            key: 0,
            loading: _ctx.isLoading,
            current: _ctx.tableData.length,
            total: _ctx.total,
            onLoadMore: _ctx.loadMoreData
          }, null, 8, ["loading", "current", "total", "onLoadMore"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      size: "70%",
      modelValue: _ctx.repairDrawer,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.repairDrawer) = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.repairLeakTitle'),
      "before-close": _ctx.handleRepairDrawerClose,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RepairDrawer, { "current-terminal": _ctx.currentItem }, null, 8, ["current-terminal"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"])
  ], 64))
}